// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".the-dark-mode-button[data-v-32b56898]{margin-right:20px;background:none;border:none;cursor:pointer;padding:0}@media (max-width:575px){.the-dark-mode-button[data-v-32b56898]{margin-right:12px}}.the-dark-mode-button__icon[data-v-32b56898]{fill:var(--color-gray-500);width:20px;height:20px}.the-dark-mode-button__icon[data-v-32b56898]:hover{opacity:.6}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
